(function () {
  if (customElements.get('install-steps')) return;

  class InstallSteps extends HTMLElement {
    connectedCallback() {
      this.index = 0;
      this.triggers = Array.from(this.querySelectorAll('[data-step-trigger]'));
      this.panels = Array.from(this.querySelectorAll('[data-step-panel]'));
      this.slides = Array.from(this.querySelectorAll('[data-step-slide]'));
      this.count = Math.max(this.triggers.length, this.panels.length, this.slides.length);

      if (this.count < 2) return;

      this.triggers.forEach((btn) => {
        btn.addEventListener('click', () => {
          this.select(Number(btn.dataset.stepTrigger));
        });
        btn.addEventListener('keydown', (event) => this.onKeydown(event));
      });

      this.applyActive(0);
      requestAnimationFrame(() => {
        this.classList.add('is-ready');
      });
    }

    onKeydown(event) {
      var delta = 0;
      if (event.key === 'ArrowDown' || event.key === 'ArrowRight') delta = 1;
      if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') delta = -1;
      if (!delta) return;

      event.preventDefault();
      var next = (this.index + delta + this.count) % this.count;
      this.select(next);
      if (this.triggers[next]) this.triggers[next].focus();
    }

    applyActive(index) {
      this.index = index;

      this.triggers.forEach((btn, i) => {
        const active = i === index;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
        btn.tabIndex = active ? 0 : -1;
      });

      this.panels.forEach((panel, i) => {
        const active = i === index;
        panel.classList.toggle('is-active', active);
        panel.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      this.slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
      });
    }

    select(index) {
      if (index < 0 || index >= this.count) return;
      this.applyActive(index);
    }
  }

  customElements.define('install-steps', InstallSteps);
})();
